/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Sub_Quotas_Unsaved_ChangesInputs */



/**
* | output |
* | --- |
* | "{count} unsaved change(s)" |
*
* @param {Sub_Quotas_Unsaved_ChangesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_quotas_unsaved_changes = /** @type {((inputs: Sub_Quotas_Unsaved_ChangesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Quotas_Unsaved_ChangesInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} nicht gespeicherte Änderung(en)`)
	return /** @type {LocalizedString} */ (`${i?.count} unsaved change(s)`)
});